import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { Sidebar } from '../../rebranding/sidebar';
import createNewStore from '../../store';
import { Switch } from './Switch';
import { ListingFilterContextProvider } from '../../rebranding/store/contexts/listingFilter';

import '../../assets/rebranding.scss';

function App() {
  return (
    <Provider store={createNewStore()}>
      <Router basename={process.env.REACT_APP_ROUTER_BASE}>
        <ListingFilterContextProvider>
          <div className="rebranding-app__container">
            <Sidebar />
            <div className="rebranding-page__container">
              <Switch />
            </div>
          </div>
        </ListingFilterContextProvider>
      </Router>
    </Provider>
  );
}

export default App;
